import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { buildOverviewItemId } from 'site-modules/personalized-search/utils/build-overview-item-id';
import { OverviewContext } from 'site-modules/personalized-search/context/overview-context/overview-context';
import { usePrevious } from 'site-modules/shared/hooks/use-previous';

const getOverviewItemsCollapseState = pageStruct => {
  const components = pageStruct?.components;
  if (!(components?.includes('overview') && pageStruct?.overview)) return {};
  const isOpenOnLoad = components.length === 1;
  return pageStruct.overview.reduce((result, overviewItem) => {
    if (!overviewItem.header) {
      return result;
    }

    const { make, model, year, trim } = overviewItem.header;
    const id = buildOverviewItemId({ year, make, model, trim });
    return { ...result, [id]: isOpenOnLoad };
  }, {});
};

export const OverviewContextProvider = ({ children, pageStruct = undefined }) => {
  const [ids, setIds] = useState(getOverviewItemsCollapseState(pageStruct));
  const prevPageStruct = usePrevious(pageStruct);

  if (prevPageStruct !== pageStruct) {
    if (pageStruct) setIds(getOverviewItemsCollapseState(pageStruct));
  }

  const updateIds = useCallback((id, isOpen) => {
    setIds(prev => ({ ...prev, [id]: isOpen }));
  }, []);

  const initialContextValue = useMemo(
    () => ({
      expandedItems: ids,
      toggleItem: updateIds,
    }),
    [ids, updateIds]
  );

  return <OverviewContext.Provider value={initialContextValue}>{children}</OverviewContext.Provider>;
};

OverviewContextProvider.propTypes = {
  pageStruct: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
};
